"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Determine if the WinningHand is a MixedOneSuit (Chinese: 混一色).
 * @param inputWinningHand WinningHand to be evaluated.
 * @returns true if the inputWinningHand is a MixedOneSuit (Chinese: 混一色).
 */
function isMixedOneSuit(inputWinningHand) {
    let containHonor = false;
    let suit = null;
    const melds = inputWinningHand.getMelds();
    for (const meld of melds) {
        const meldSuit = meld.getSuitType();
        if (meldSuit === 'honor') {
            containHonor = true;
            continue;
        }
        else if (suit === null) {
            suit = meldSuit;
        }
        else {
            if (meldSuit !== suit) {
                return false;
            }
        }
    }
    return containHonor;
}
exports.default = isMixedOneSuit;
